import React, { Component } from 'react';

export default class Watchlist extends Component {
    render () {
        return<div>
            watchlist here
        </div>
    }
}